export const baseProductConfigurationSlotId = 'base-product-configuration-slot';

export const baseProductConfigurationStepId = 'base-product-configuration';
